export default "__VITE_ASSET__Bwyu$FmL__"